<template>
  <PageLayout class="news-page">
    <PageTitle class="page-title">Новини</PageTitle>
    <ShowNews />
  </PageLayout>
</template>

<script>
import { mapActions } from 'vuex';
import ShowNews from '../../views/news/show.vue';
import { pages } from '@/entities/current-page';
import { PageLayout } from '@/shared/ui/layouts';
import { PageTitle } from '@/shared/ui/page-title';
import {Divider} from "@/shared/ui/divider";

export default {
  created() {
    this.changeActivePage(pages.RESOURCES);
  },
  components: {Divider, PageLayout, PageTitle, ShowNews },
  methods: {
    ...mapActions('currentPageModule', ['changeActivePage']),
  },
};
</script>

<style lang="scss" scoped>
.page-title {
  font-size: 30px;
  line-height: 44px;
  color: #24282c;
  font-weight: 700;
  margin-bottom: 8px !important;
}

::v-deep button {
  text-align: center;
}

::v-deep input {
    border: 1px solid #dde2e5 !important;
    border-radius: 3px !important;

    &:hover {
        border-color: #ffad3d !important;
    }
}

::v-deep .multiselect__input {
    border: none !important;
}
</style>
